import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {useAppDispatch, useAppSelector} from 'src/redux/hooks';
import {setProjectScopeAndReset} from 'src/redux/slices/projectScopeSlice';
import {SidebarFooterSelect} from './SidebarFooterSelect';

export const ProjectScopeSelect: React.FC = () => {
  const dispatch = useAppDispatch();
  const projectScope = useAppSelector(state => state.projectScope.scope);
  const options = useAppSelector(state => state.projectScope.options);
  const isLoading = useAppSelector(state => state.projectScope.isLoading);

  const handleChange = (value: string | null): void => {
    if (!value) {
      dispatch(setProjectScopeAndReset(null));
      return;
    }
    const option = options.find(o => String(o.id) === value);
    if (!option) return;
    dispatch(
      setProjectScopeAndReset({id: option.id, name: option.label ?? ''})
    );
  };

  if (options.length === 0) return null;

  return (
    <Box mx="sm">
      <SidebarFooterSelect
        label="Project"
        data={options.map(o => ({value: String(o.id), label: o.label ?? ''}))}
        value={projectScope ? String(projectScope.id) : null}
        onChange={handleChange}
        isLoading={isLoading}
        clearable
        placeholder="All projects"
        highlighted={projectScope !== null}
      />
    </Box>
  );
};
